import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Box, Grid, TextField, Button, InputLabel, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { makeApiRequest } from '../../../utils/api';

const AddTask = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        name: localStorage.getItem('username'),
        taskName: '',
        date: today.toISOString().split('T')[0], // Default to today
        inTime: '',
        outTime: '',
        description: '',
        control: 2,
        userid: localStorage.getItem('userid')
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            setError(null);
            if (formData.taskName == '' || formData.inTime == '' || formData.outTime == '' || formData.description == '') {
                toast.warn("Please fill all the data")
                return
            }
            const response = await makeApiRequest('post', '/api/learning/add', {
                token: localStorage.getItem('authToken'),
                data: formData
            });

            if (response.status === 'success') {
                toast.success(response.message);
                window.location.reload(false);

            } else {
                throw new Error('Invalid attendance data received');
            }
        } catch (err) {
            console.error('Error fetching attendance data:', err);
            setError(err.response?.data?.message || 'Error fetching attendance data');

        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                height: 'auto',
                backgroundColor: '#f1f4f9',
                minHeight: "100vh",
                maxHeight: 'auto'
            }}
        >
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
            <Grid container sx={{ height: "auto", width: "100%", display: "flex", justifyContent: "center", }}>
                <Grid item xs={11} sx={{ height: "80px", width: "100%", display: "flex", alignItems: "center" }}>

                    <Typography variant="h5" gutterBottom
                        sx={{
                            fontSize: { xs: "24px", sm: "34px" },
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "160%",
                            letterSpacing: "0.15px",
                            color: "#481E82",
                            // paddingLeft: '15px',
                            paddingTop: '20px'
                        }}>
                        Add Task
                    </Typography>
                </Grid>
                <Grid item xs={11}>

                    <Box
                        sx={{
                            // maxWidth: 1000,
                            // width: { xs: '75%', sm: '85%' },
                            mx: 'auto',
                            p: 3,
                            borderRadius: 2,
                            boxShadow: 3,
                            backgroundColor: 'white'
                        }}
                    >

                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        size='small'
                                        sx={{
                                            width: "100%",
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        }}
                                        required
                                        label="Name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth
                                        sx={{ maxWidth: "100%" }}
                                        size="small">
                                        <InputLabel id="date-label">Date</InputLabel>
                                        <Select
                                            labelId="date-label"
                                            name="date"
                                            value={formData.date}
                                            onChange={handleChange}
                                            variant="outlined"
                                            label="Date"
                                        >
                                            <MenuItem value={today.toISOString().split('T')[0]}>Today</MenuItem>
                                            <MenuItem value={yesterday.toISOString().split('T')[0]}>Yesterday</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        size='small'
                                        sx={{
                                            width: "100%",
                                        }}
                                        label="Task Name"
                                        name="taskName"
                                        value={formData.taskName}
                                        onChange={handleChange}
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        size='small'
                                        sx={{
                                            width: "100%",
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        }}
                                        required
                                        type="time"
                                        label="In Time"
                                        name="inTime"
                                        value={formData.inTime}
                                        onChange={handleChange}
                                        onFocus={(e) => e.target.showPicker()}
                                        InputLabelProps={{ shrink: true }}
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        size='small'
                                        sx={{
                                            width: "100%",
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        }}
                                        required
                                        type="time"
                                        label="Out Time"
                                        name="outTime"
                                        value={formData.outTime}
                                        onChange={handleChange}
                                        onFocus={(e) => e.target.showPicker()}
                                        InputLabelProps={{ shrink: true }}
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={4}
                                        label="Description (Max 250 Chars)"
                                        name="description"
                                        value={formData.description}
                                        required
                                        sx={{
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        }}
                                        onChange={handleChange}
                                        // onFocus={(e) => e.target.showPicker()}
                                        inputProps={{ maxLength: 250 }}
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>

                            <Box mt={3} display="flex" justifyContent="flex-end">
                                <Button variant="contained" type="submit" color="primary">
                                    ADD
                                </Button>
                            </Box>
                        </form>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AddTask;
